/* eslint-disable */
/* oxlint-disable */
/* prettier-ignore-file */
// @ts-nocheck
// This file is auto-generated. Do not edit manually.
// Run 'pnpm codegen' to regenerate this file.

import Num, { BigNumber } from '@flipster/utils/num';
import { dateToEpochString, timestampToDate } from '@flipster/utils/datetime';

export type PrexDecimal = BigNumber;
export type PrexDecimalJsonValue = string;
export function PrexDecimal_fromJsonValue(json: PrexDecimalJsonValue): PrexDecimal {
  return Num(json);
}
export function PrexDecimal_toJsonValue(value: PrexDecimal): PrexDecimalJsonValue {
  return String(value);
}

export type PrexTimestamp = Date;
export type PrexTimestampJsonValue = string;
export function PrexTimestamp_fromJsonValue(json: PrexTimestampJsonValue): PrexTimestamp {
  return timestampToDate(json);
}
export function PrexTimestamp_toJsonValue(value: PrexTimestamp): PrexTimestampJsonValue {
  return dateToEpochString(value);
}
